import { loading } from './modules/loading';
import { mv } from './modules/mv';
import { time } from './modules/time';
import { dragscroll } from './modules/dragscroll';
loading();
mv();
time();
dragscroll();
dragscroll();
